import React from 'react'
import { DcInput, PixelCurrency } from 'pixel-base'
import styled from 'styled-components'

import { Container, Product } from './LineItems'
import { HeaderTitle, TableHeader } from './MergeOrders'
import { InlineSection } from '../OrderDetails/components/subComponents/ProductLineItem'

interface IProps {
  item: {
    quantity: number
    variation_id: number
  }
  index: number
  updateQuantity: (value: number, variation_id: number) => void
}
const SubOrders = (props: IProps) => {
  const { item, index, updateQuantity } = props
  return (
    <Container>
      {index === 0 && (
        <TableHeader>
          <HeaderTitle width={'50%'}>Qty</HeaderTitle>
          <HeaderTitle width={'50%'}>Total</HeaderTitle>
        </TableHeader>
      )}
      <Product>
        <Quantity>
          <InlineSection>
            <DcInput
              name="quantity"
              noPadding
              type="number"
              value={item.quantity}
              min={0}
              onChange={(e) => {
                updateQuantity(e.target.value, item.variation_id)
              }}
            />
          </InlineSection>
        </Quantity>
        <Total>
          <InlineSection>
            <PixelCurrency value={item.quantity * item.price} />
          </InlineSection>
        </Total>
      </Product>
    </Container>
  )
}
const Quantity = styled.div`
  width: 50%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  padding: 0px 20px;
`
const Total = styled.div`
  width: 50%;
  display: flex;
  flex-direction: row;
`
export default SubOrders
